export const localVariables = {
    REMEMBER_PATH: 'REMEMBER_PATH',
    ACCESSTOKEN: 'accessToken',
    accessTokenExp: 'accessTokenExp',
    UID: 'uId',
    USER: 'user',
    ROLES: 'roles',
    LANGUAGE: 'lang'
};

export const LANGUAGE = [
    { key: 'vi', label: 'vietnamese', icon: '../assets/images/flags/vn.svg' },
    { key: 'en', label: 'english', icon: '../assets/images/flags/us.svg' }
];

export const STUDENT_STATUS = {
    NOT_TESTED: 'NOT_TESTED',
    TESTED: 'TESTED',
    STUDYING: 'STUDYING',
    COMPLETED: 'COMPLETED',
    ON_LEAVE: 'ON_LEAVE'
};

export const DOCUMENT_TYPE = {
    AVATAR: 'AVATAR',
    RECORD_LESSON: 'RECORD_LESSON',
    THUMBNAIL: 'THUMBNAIL'
};

export const STUDENT_TEST_TYPE = [
    { key: 'IELTS', label: 'IELTS' },
    { key: 'ENGLISH_COMMUNICATION', label: 'English Communication' },
    { key: 'BUSINESS_ENGLISH', label: 'Business English' },
    { key: 'CHINESE_FOR_STUDYING_ABROAD', label: 'Chinese for studying abroad' },
    { key: 'CHINESE_COMMUNICATION', label: 'Chinese Communication' },
    { key: 'BUSINESS_CHINESE', label: 'Business Chinese' }
];

export const STUDENT_STATUS_COLOR = {
    [STUDENT_STATUS.NOT_TESTED]: 'red',
    [STUDENT_STATUS.TESTED]: 'green',
    [STUDENT_STATUS.STUDYING]: 'blue',
    [STUDENT_STATUS.COMPLETED]: 'purple',
    [STUDENT_STATUS.ON_LEAVE]: 'orange'
};

export const STUDENT_STATUS_TEXT = {
    [STUDENT_STATUS.NOT_TESTED]: 'Not Tested',
    [STUDENT_STATUS.TESTED]: 'Tested',
    [STUDENT_STATUS.STUDYING]: 'Studying',
    [STUDENT_STATUS.COMPLETED]: 'Completed',
    [STUDENT_STATUS.ON_LEAVE]: 'On Leave'
};
